import { createContext, useContext, useState, useEffect } from 'react';
import api, { settingsService } from '../services/api';

const SettingsContext = createContext(null);

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        // Utiliser settingsService.getAll() au lieu de getPublic()
        const response = await settingsService.getAll();
        console.log('Settings chargés (une seule fois):', response.data);
        
        if (response.data.settings) {
          setSettings(response.data.settings);
        } else if (response.data) {
          setSettings(response.data);
        }
      } catch (error) {
        console.error('Erreur chargement settings:', error);
        setSettings({
          contact_phone: '+225 07 67 81 19 99',
          contact_email: 'contact@wealthtech-pro.com',
          contact_address: 'Abidjan, Côte d\'Ivoire'
        });
      } finally {
        setLoading(false);
      }
    };

    fetchSettings();
  }, []);

  // Valeurs extraites
  const phoneNumber = settings.contact_phone || '';
  const email = settings.contact_email || '';
  const address = settings.contact_address || '';
  const siteName = settings.site_name || 'WealthTech Pro';
  const siteTagline = settings.site_tagline || '';
  const heroTitle = settings.hero_title || '';
  const heroSubtitle = settings.hero_subtitle || '';
  const socialLinkedin = settings.social_linkedin || '';
  const socialTwitter = settings.social_twitter || '';

  return (
    <SettingsContext.Provider value={{ 
      settings, 
      loading,
      phoneNumber,
      email,
      address,
      siteName,
      siteTagline,
      heroTitle,
      heroSubtitle,
      socialLinkedin,
      socialTwitter
    }}>
      {children}
    </SettingsContext.Provider>
  );
}

export function useSettings() {
  const context = useContext(SettingsContext);
  if (!context) {
    throw new Error('useSettings doit être utilisé dans un SettingsProvider');
  }
  return context;
}

export default SettingsContext;